export default __webpack_public_path__ + "static/media/091-house-2.db516dc4.svg";